document.addEventListener('input', function(e) {
  if (e.target && e.target.id === 'codiceFiscale') {
    const start = e.target.selectionStart;
    const end = e.target.selectionEnd;
    
    e.target.value = e.target.value.toUpperCase();
    
    e.target.setSelectionRange(start, end);
  }
});

(function() {
  function patchGetFiscalForm(form) {
    if (!form.hasAttribute('aria-label')) {
      form.setAttribute('aria-label', 'Informazioni di fatturazione');
    }
  }

  function patchGetFiscalSVGs(root) {
    root.querySelectorAll('.invoice-popup-form svg').forEach(function(svg) {
      svg.setAttribute('aria-hidden', 'true');
      svg.setAttribute('focusable', 'false');
    });
  }

  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      mutation.addedNodes.forEach(function(node) {
        if (node.nodeType !== 1) return;
        if (node.matches && node.matches('form.invoice-request-form')) {
          patchGetFiscalForm(node);
        }
        node.querySelectorAll && node.querySelectorAll('form.invoice-request-form').forEach(patchGetFiscalForm);
        patchGetFiscalSVGs(node);
      });
    });
  });

  observer.observe(document.body, { childList: true, subtree: true });

  document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll('form.invoice-request-form').forEach(patchGetFiscalForm);
    patchGetFiscalSVGs(document);
  });
})();

function moveRecaptchaBadge(attempts = 0) {
  // mica all'infinito
  if (attempts > 100) return;

  const badge = document.querySelector('.grecaptcha-badge');
  const footer = document.querySelector('footer.group--footer');

  if (badge && footer) {
    footer.appendChild(badge);
    return;
  }

  requestAnimationFrame(() => moveRecaptchaBadge(attempts + 1));
}

document.addEventListener('DOMContentLoaded', moveRecaptchaBadge);